


























































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ApolloClient, { serverBase } from "../apollo";
import gql from "graphql-tag";

@Component
export default class CreatedCustomField extends Vue {
  @Prop() value!: any;
  editDialog = false;
  isEditing = false;
  validEdit = false;

  editName = "" as string | null;
  editUnit = null as string | null;
  editValues = [] as string[];

  fieldNameRules = [v => (!!v && !!v.length) || "Invalid field name"];

  deleteState = 0;

  titleCase(str: string) {
    return str
      .split(" ")
      .map(w => w[0].toUpperCase() + w.substr(1).toLowerCase())
      .join(" ");
  }

  edit() {
    if (!this.validEdit) return;

    this.isEditing = true;

    ApolloClient.mutate({
      mutation: gql`
        mutation(
          $id: String!
          $name: String
          $values: [String!]
          $unit: String
        ) {
          updateCustomField(
            id: $id
            name: $name
            values: $values
            unit: $unit
          ) {
            _id
            name
            type
            values
            unit
          }
        }
      `,
      variables: {
        id: this.value._id,
        name: this.editName,
        values: this.editValues,
        unit: this.editUnit
      }
    })
      .then(res => {
        this.$emit("update", res.data.updateCustomField);
        this.editDialog = false;
      })
      .finally(() => {
        this.isEditing = false;
      });
  }

  openEditDialog() {
    this.editDialog = true;
    this.editName = this.value.name;
    this.editUnit = this.value.unit;
    this.editValues = this.value.values || [];
  }

  deleteHandler() {
    if (this.deleteState == 0) {
      this.deleteState++;
      setTimeout(() => {
        this.deleteState = 0;
      }, 2500);
    } else {
      ApolloClient.mutate({
        mutation: gql`
          mutation($id: String!) {
            removeCustomField(id: $id)
          }
        `,
        variables: {
          id: this.value._id
        }
      }).then(res => {
        this.$emit("delete");
      });
    }
  }
}
